<template>
  <md-dialog
    :md-active.sync="showDialog"
    class="med-route-dialog new-globals"
    @md-clicked-outside="clickOutside"
  >
    <md-dialog-title>{{ newMedication ? 'New Medication' : 'New Route' }}</md-dialog-title>
    <md-dialog-content>
      <md-field v-if="newMedication">
        <label>Name</label>
        <md-input
          v-model="state.name"
        />
      </md-field>
      <md-field>
        <label for="routeType">Route Type</label>
        <md-select v-if="newMedication" id="routeType" v-model="state.selectedRoutes" multiple>
          <md-option
            v-for="route in routes"
            :key="route.key"
            :value="route.key"
          >
            {{ route.name.en }}
          </md-option>
        </md-select>
        <md-select v-else id="routeType" v-model="state.selectedRoute">
          <md-option
            v-for="route in routes"
            :key="route.key"
            :value="route.key"
          >
            {{ route.name.en }}
          </md-option>
        </md-select>
      </md-field>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="cancel">Cancel</md-button>
      <md-button
        class="md-primary"
        :disabled="inputNeeded"
        @click="submit"
      >
        Submit
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: 'new-med-route-dialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    newMedication: {
      type: Boolean,
      default: false,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDialog: false,
      state: {
        name: 'null',
        selectedRoutes: [],
        selectedRoute: null,
      }
    };
  },
  computed: {
    inputNeeded() {
      if (this.newMedication) {
        return !this.state.name || this.state.selectedRoutes.length === 0;
      } else {
        return !this.state.selectedRoute;
      }
    }
  },
  watch: {
    show(value) {
      this.showDialog = value;
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    cancel() {
      this.state.showDialog = false;
      this.$emit('cancel');
      this.reset();
    },
    submit() {
      this.state.showDialog = false;
      if (this.newMedication) {
        this.$emit('submit', this.state.name, this.state.selectedRoutes);
      } else {
        this.$emit('submit', this.state.selectedRoute);
      }
      this.reset();
    },
    clickOutside() {
      this.cancel();
    },
    reset() {
      this.state.name = 'New Medication';
      this.state.selectedRoutes = [];
      this.state.selectedRoute = null;
    },
  }
}
</script>

<style scoped>
.med-route-dialog {
  height: auto;
}
</style>